import { combineReducers } from "redux";

import Auth from "./auth/reducers";
import Layout from "./layout/reducers";
import Category from "./category/reducers";
import Course from "./course/reducers";
import SubCourse from "./subCourse/reducers";
import Video from "./video/reducers";
import News from "./news/reducers";
import WhoAreWe from "./whoAreWe/reducers";
import Faq from "./faq/reducers";
import Testimonials from "./testimonials/reducers";
import Banners from "./banner/reducers";
import Users from "./users/reducers";
import Orders from "./orders/reducer";
import MainBanner from "./Main_banner/reducers";
import Enquiry from "./Enquiries/reducer";
import Subscriptions from "./Subscriptions/reducer";
import NewsBanner from "./news_banner/reducers";
import Currency from "./currency/reducers";
import Revenue from "./revenue/reducers";
import Footer from "./footer/reducers";
import Influencer from "./Influencer/reducers";
import CongratsBox from "./congratsBox/reducers";
import Coupon from "./Coupons/reducers";
import Payout from "./payout/reducers";

export default combineReducers({
  Auth,
  Layout,
  Category,
  Course,
  SubCourse,
  Video,
  Orders,
  Enquiry,
  Subscriptions,
  News,
  NewsBanner,
  WhoAreWe,
  MainBanner,
  Faq,
  Testimonials,
  Banners,
  Users,
  Currency,
  Footer,
  Revenue,
  Influencer,
  Coupon,
  CongratsBox,
  Payout
});
